module.exports = __webpack_public_path__ + "img/icon-score6.e2b0ddd0.svg";